import { useMutation } from '@apollo/client'
import { useState } from 'react'
import { MANUAL_ADD_PAYEES_MUTATION } from '../../../graphql/mutation/payees/add/payees.graphql'
import { getGraphQLAPIErrors } from '../../../utils/servicesUtils'

export const useManualService = () => {
  const [errorObj, setErrorObj] = useState(null)
  const [
    loadApi,
    { called = true, loading: gqlLoading = true, data: gqlData = null }
  ] = useMutation(MANUAL_ADD_PAYEES_MUTATION, {
    onError: ({ graphQLErrors, networkError }) => {
      getGraphQLAPIErrors({ graphQLErrors, networkError, setErrorObj })
    }
  })

  return {
    loadApi,
    called,
    loading: gqlLoading,
    data: gqlData,
    error: errorObj
  }
}
export default useManualService
